import React, { Component } from "react";

export default class Label extends Component {
  render() {
    return (
      <div>
        <label htmlFor={this.props.htmlFor} className="col-sm-12">
          {this.props.children}
          {this.props.isRequired && <span className="text-danger">*</span>}
        </label>
      </div>
    );
  }
}
